import { OptionsType } from '@europrocurement/flexy-components';

const useTypeRecupGreffe = () => {
    const typesRecupGreffe: OptionsType = [
        { value: 'CLIENTOPERE', label: 'Via le client opéré' },
        { value: 'GREFFEFORMULAIRE', label: 'Via le formulaire' },
    ];

    const getGreffeLabel = (typeRecup: string): string | undefined =>
        typesRecupGreffe.find((type) => type.value === typeRecup)?.label;

    return { typesRecupGreffe, getGreffeLabel };
};

export default useTypeRecupGreffe;
